import angular from 'angular'

import { env } from '../../../lib/env'
import { WEB_REGISTER } from '../components/web-register.constant'

/**
 * Intercepts $http api requests and passes identifying headers
 *
 * @module webregister.http.apiIdentification
 */
angular
  .module('webregister.http')
  .factory('apiIdentification', function ApiIdentification() {
    // These values are transformed at build time using '@rollup/plugin-replace'. See gulp/partial-tasks/rollup.js
    const CLIENT_VERSION = WEB_REGISTER.CLIENT_VERSION
    const CLIENT_TIMESTAMP = process.env.COMMIT_TIME

    let requestCount = 0
    let countRequestsMade = false

    function isApiRequest(config: $TSFixMe) {
      return config.url.indexOf('/api') === 0
    }

    function onRequest(config: $TSFixMe) {
      // Identify all Ajax requests as being XMLHttpRequest - this is currently how the server excludes the various
      // sell screen clients from rate limiting
      config.headers['X-Requested-With'] = 'XMLHttpRequest'

      if (isApiRequest(config)) {
        config.headers['X-Vend-Client-Platform'] = WEB_REGISTER.APPLICATION_NAME

        if (env.isProduction()) {
          config.headers['X-Vend-Client-Version'] = CLIENT_VERSION
          config.headers['X-Vend-Client-Timestamp'] = CLIENT_TIMESTAMP
        }

        if (countRequestsMade) {
          requestCount++
        }
      }
      return config
    }

    function startCountingRequests() {
      countRequestsMade = true
      requestCount = 0
    }

    function stopCountingRequests() {
      countRequestsMade = false
      return requestCount
    }

    function getRequestCount() {
      return requestCount
    }

    return {
      request: onRequest,
      startCountingRequests,
      stopCountingRequests,
      getRequestCount,
    }
  })
